import { Controller } from "@hotwired/stimulus";
import { selectedOptionFor } from "../../utils/inputs_utils";
import { formattedDate, setFlatpickrMinDate } from "../../utils/date_utils";
import { numberToCurrency } from "../../utils/number_utils";

export default class extends Controller {
  static targets = ["formContent", "selectInput", "supplier", "date", "amount", "disposalDateInput"];
  static outlets = ["fixed-assets--fiscal-year-disposal-form"];

  displayForm() {
    const selectedFixedAsset = this._selectedFixedAsset();
    this._displayFixedAssetInformation(selectedFixedAsset);
    this._updateDisposalDateMinDate(selectedFixedAsset);
    this.selectInputTarget.classList.add("hidden");
    this.formContentTarget.classList.remove("hidden");
    this.fixedAssetsFiscalYearDisposalFormOutlet.disableFixedAssetFromTemplateSelection(selectedFixedAsset.value);
  }

  remove() {
    this.fixedAssetsFiscalYearDisposalFormOutlet.enableFixedAssetFromTemplateSelection(
      this._selectedFixedAsset().value
    );
    this.element.remove();
    this.fixedAssetsFiscalYearDisposalFormOutlet.ensureAtLeastOneDisposedFixedAsset();
  }

  _displayFixedAssetInformation(selectedFixedAsset) {
    this.supplierTarget.textContent = selectedFixedAsset.dataset.supplier;
    this.dateTarget.textContent = formattedDate(selectedFixedAsset.dataset.date);
    this.amountTarget.textContent = numberToCurrency(selectedFixedAsset.dataset.amount);
  }

  _selectedFixedAsset() {
    return selectedOptionFor(this.selectInputTarget);
  }

  _updateDisposalDateMinDate(selectedFixedAsset) {
    setFlatpickrMinDate(this.disposalDateInputTarget, selectedFixedAsset.dataset.date);
  }
}
